import React from 'react';
import { makeStyles } from '@mui/styles';
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";


const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    //border: "2px solid #000",
    // boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius : "10px"
    
  }
}));
const QuestionNoList = (props) => {
  const classes = useStyles();
    const {testData, setQuestionNo, questionNo, setQuestionChange, _navFlag} = props;

    const questionClicked = (questionNumber) => {
   
      setQuestionNo(questionNumber);
      setQuestionChange(true);
      //setQuestion()
    }
    const [anchorEl, setAnchorEl] = React.useState("false");

    const handleClick = () => {
      setAnchorEl("true");
      const mainLayout = document.getElementById("main-layout");
      const mainBody = document.getElementById("main-body");
      if (mainLayout) {
        mainLayout.style.background = '#dddddd';
        mainLayout.style.display = 'block';
      }
      if (mainBody) {
        mainBody.style.overflow = 'hidden';
      }
    };

    const handleClose = () => {
      setAnchorEl("false");
      const mainLayout = document.getElementById("main-layout");
      const mainBody = document.getElementById("main-body");
      if (mainLayout) {
        mainLayout.style.display = '';
        mainLayout.style.background = '';
      }
      if (mainBody) {
        mainBody.style.overflow = '';
      }
    };

    const open = Boolean(anchorEl);
    const _id = open ? 'simple-popover' : undefined;

    return (
        <>
        {
        anchorEl === "false" ?
        <li className="nav-line-right" onClick={handleClick} style={{cursor:'pointer'}}>
        <img alt="" onClick={handleClick} style={{cursor:'pointer'}} src={require('../images/queno.png')}/>
        </li>
        :<li className="nav-line-right" onClick={handleClose}  style={{cursor:'pointer'}}>
        <img alt="" onClick={handleClick} style={{cursor:'pointer'}} src={require('../images/queno.png')}/>
        </li>
        }

        {/* {
          anchorEl === "true" ?
          <>
        <div className="queno-drop-two" 
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
      >
						<ul className="list-inline questionno-list">
            {testData.map((value, index) => (
                <li onClick={props.navFlag === true?()=>questionClicked(index+1):''} >
                  <a 
                  className={(value.buttonStyle === 'Answered') ? 'visited' : (value.buttonStyle === 'Not Answered') ? 'left' : (value.buttonStyle === 'Marked Review') ? 'review' : (questionNo === (index+1)) ? 'active' :''}
                   
                >
                  {index + 1}</a></li>
            ))}
						</ul>

	   </div>
     
     </>
     :
     <></>
              } */}
              {
          anchorEl === "true" ?
               <Modal
      disableEnforceFocus = {true}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={Boolean(anchorEl)}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}      PaperProps={{
        style: {
          backgroundColor:"#e5e5e9"
        }
      }}
    >
      <Fade in={anchorEl}>
        {/* <div className={classes.paper}> */}
        
        <div className="queno-drop-two">
						<ul className="list-inline questionno-list">
            {testData.map((value, index) => (
                <li onClick={props.navFlag === true?()=>questionClicked(index+1):''} >
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="#" 
                  className={(value.buttonStyle === 'Answered') ? 'visited' : (value.buttonStyle === 'Not Answered') ? 'left' : (value.buttonStyle === 'Marked Review') ? 'review' : (questionNo === (index+1)) ? 'active' :''}
                   
                >
                  {index + 1}</a></li>
            ))}
						</ul>

	   </div>
                 
       
      </Fade>
    </Modal> : <></>}

      </>
    );
}

export default QuestionNoList;
